import React, { useState } from "react";
import { Button, Card, Form, Input, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import auth from "../../firebaseConfig";
import { API_URL } from "../../config";

const SignUp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setError(null);
    try {
      const firebaseResult = await createUserWithEmailAndPassword(
        auth,
        values.email,
        values.password,
      );
      const currentUser = auth.currentUser;

      if (currentUser) {
        const token = await currentUser.getIdToken();

        const doctorResult = await fetch(`${API_URL}/doctor/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            company_id: values.companyname,
            firebase_id: firebaseResult.user.uid,
            doctor_id: btoa(values.email),
            salutation: "Dr.",
            first_name: values.name.split(" ")[0],
            last_name: values.name.split(" ").slice(1).join(" "),
            phone_number: null,
            email_address: values.email,
            date_of_birth: "2001-06-22",
            gender: "Unspecified",
          }),
        });

        if (!doctorResult.ok) {
          sessionStorage.clear();
          const doctorError = await doctorResult.json();
          throw new Error(
            doctorError.message || "Failed to register doctor data",
          );
        }

        navigate("/login");
      } else {
        setError("Failed to retrieve current user");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card title="Create an account" bordered={false} style={{ width: 300 }}>
        <Form name="signup" onFinish={onFinish}>
          <Form.Item
            name="name"
            rules={[{ required: true, message: "Please input your name!" }]}
          >
            <Input placeholder="Name" />
          </Form.Item>
          <Form.Item
            name="companyname"
            rules={[{ required: true, message: "Please input your name!" }]}
          >
            <Input placeholder="Company Id" />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[{ required: true, message: "Please input your email!" }]}
          >
            <Input placeholder="Email" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Sign Up
            </Button>
          </Form.Item>
        </Form>
        {error && <Typography.Text type="danger">{error}</Typography.Text>}
        <Button type="link" onClick={() => navigate("/login")}>
          Already have an account? Log In
        </Button>
      </Card>
    </div>
  );
};

export default SignUp;
